import { render, staticRenderFns } from "./QuizStart.vue?vue&type=template&id=0d95a756&scoped=true&"
import script from "./QuizStart.vue?vue&type=script&lang=js&"
export * from "./QuizStart.vue?vue&type=script&lang=js&"
import style0 from "./QuizStart.vue?vue&type=style&index=0&id=0d95a756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95a756",
  null
  
)

export default component.exports